import React, { useState } from 'react'

import { Card, IconButton, CloseIcon } from '@paypalcorp/pp-react'
import FeedbackRating from './FeedbackRating'
import FeedbackReason from './FeedbackReason'

const Feedback = ({
  answerId,
  searchID,
  closeDialog,
  setIsFeedbackOpen,
  setFeedbackSent,
}: {
  answerId: string
  searchID: string
  closeDialog: () => void
  setIsFeedbackOpen: React.Dispatch<React.SetStateAction<boolean>>
  setFeedbackSent: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  const [selectedRating, setSelectedRating] = useState(0)

  return (
    <Card>
      <IconButton
        buttonType="tertiary"
        size="xs"
        svgIconComponent={CloseIcon}
        onClick={closeDialog}
        style={{ float: 'right' }}
      />
      <FeedbackRating
        answerId={answerId}
        searchID={searchID}
        selectedRating={selectedRating}
        setSelectedRating={setSelectedRating}
      />
      <FeedbackReason
        answerId={answerId}
        searchID={searchID}
        selectedRating={selectedRating}
        setIsFeedbackOpen={setIsFeedbackOpen}
        setFeedbackSent={setFeedbackSent}
      />
    </Card>
  )
}

export default Feedback
